
import { Model } from './model';

export class WebObjectModel implements Model {
  name: string="";
  _id: string="";
  webobjectType: string="";
  dom_name: string="";
  xpath: string="";
  dom_id: string="";
  class: string="";
  css: string="";
  link: string="";
  horizontal_index:string="";
  partial_link: string="";
  tag: string="";
  desc: string="";
  webpageId: string="";
  warnings:any={};
  selectedWebPageId:any = {};
  xpaths: string[] = [];
  type: string;
  deleted: number;
  collectionName: string;
  request: any;
  dbName: string;
  webPageId: string;
}
